import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import PurchaseReducer from './PurchaseReducer/PurchaseReducer';
import PettyCashReducer from './PettyCashReducer/PettyCashReducer';
// Sub Petty Cash (Manufacturer only) — see SubPettyCashAction.js. Only ever
// populated when the logged-in company is a manufacturer.
import SubPettyCashReducer from './SubPettyCashReducer/SubPettyCashReducer';
import ReportsReducer from './ReportsReducer/ReportsReducer';
import ProductReducer from './ProductReducer/ProductReducer';
import CategoryReducer from './ProductReducer/CategoryReducer';
import StockReducer from './StockReducer/StockReducer';
import SalesReducer from './SalesReducer/SalesReducer';
import ClientReducer from './ClientsReducer/ClientsReducer';
import UsersReducer from './UserReducer/UserReducer';
import WastageReportReducer from './WastageReportReducer/WastageReportReducer';
import BankReducer from './BankReducer/BankReducer';
import BankTransactionReducer from './BankReducer/BankTransactionReducer';
import DashboardReducer from './DashboardReducer/DashboardReducer';
import EmployeeReducer from './EmployeeReducer/EmployeeReducer';
import SalaryReducer from './SalaryReducer/SalaryReducer';
import HrmsPayslipReducer from './HrmsPayslipReducer/HrmsPayslipReducer';
import LoanReducer from './LoanReducer/LoanReducer';
import NotificationReducer from './NotificationReducer/NotificationReducer';
import ReturnReducer from './ReturnReducer/ReturnReducer';
import CompanyReducer from './companyReducer/companyReducer';
import AuthReducer from './AuthReducer/AuthReducer';
import CreditReducer from './CreditReducer/CreditReducer';
// Manufacturer Module — Phase 3 (BOM Recipes + Production Orders).
// Only ever populated when the logged-in company is a manufacturer
// (BomAction.js / ProductionAction.js are only dispatched from that
// context) — untouched for every other company type.
import BomReducer from './ManufacturerReducer/BomReducer';
import ProductionReducer from './ManufacturerReducer/ProductionReducer';
// Manufacturer Module — Phase 5 (Trade Price Levels + Low-Stock Alerts).
// Only ever populated when the logged-in company is a manufacturer
// (PriceLevelAction.js is only dispatched from that context) —
// untouched for every other company type.
import PriceLevelReducer from './ManufacturerReducer/PriceLevelReducer';
// Manufacturer Module — Customer Classification (Retailer / Madaris /
// HORECA etc.). Only ever populated when the logged-in company is a
// manufacturer (CustomerTypeAction.js is only dispatched from that
// context) — untouched for every other company type.
import CustomerTypeReducer from './ManufacturerReducer/CustomerTypeReducer';
// Manufacturer Module — Phase 6, Batch 1 (Delivery Challan).
// Only ever populated when the logged-in company is a manufacturer
// (DeliveryChallanAction.js is only dispatched from that context) —
// untouched for every other company type.
import DeliveryChallanReducer from './ManufacturerReducer/DeliveryChallanReducer';
// Manufacturer Module — Phase 6, Batch 2 (Invoice).
// Only ever populated when the logged-in company is a manufacturer
// (InvoiceAction.js is only dispatched from that context) — untouched
// for every other company type.
import InvoiceReducer from './ManufacturerReducer/InvoiceReducer';
// Manufacturing tab (NEW standalone module — Suppliers/Raw Material/
// Ready Material/Accounts). Separate from the older manufacturer/
// recipes+production BOM system above; only ever populated when the
// logged-in company is a manufacturer.
import ManufacturingSupplierReducer from './ManufacturingReducer/ManufacturingSupplierReducer';
import ManufacturingRawMaterialReducer from './ManufacturingReducer/ManufacturingRawMaterialReducer';
import ManufacturingReadyMaterialReducer from './ManufacturingReducer/ManufacturingReadyMaterialReducer';
import ManufacturingAccountsReducer from './ManufacturingReducer/ManufacturingAccountsReducer';
// Order Fulfillment module (Phase 2A) — standalone, WhatsApp/PDF order
// tracking. NOT manufacturer-only; visible to any company type that gets
// the fulfillment_orders.* permissions assigned.
import FulfillmentOrderReducer from './FulfillmentOrderReducer/FulfillmentOrderReducer';

// Combine both reducers into a single root reducer
const rootReducer = combineReducers({
  auth: AuthReducer,
  product: ProductReducer,
  category: CategoryReducer,
  stock: StockReducer,
  sales: SalesReducer,
  clients: ClientReducer,
  purchase: PurchaseReducer,
  users: UsersReducer,
  pettyCash: PettyCashReducer,
  subPettyCash: SubPettyCashReducer,
  wastageReport: WastageReportReducer,
  bank: BankReducer,
  bankTransactions: BankTransactionReducer,
  dashboard: DashboardReducer,
  employees: EmployeeReducer,
  salary: SalaryReducer,
  hrmsPayslips: HrmsPayslipReducer,
  reports: ReportsReducer,
  loans: LoanReducer,
  notification: NotificationReducer,
  returns: ReturnReducer,
  company: CompanyReducer,
  credit: CreditReducer,
  bom: BomReducer,
  production: ProductionReducer,
  priceLevel: PriceLevelReducer,
  customerType: CustomerTypeReducer,
  deliveryChallan: DeliveryChallanReducer,
  invoice: InvoiceReducer,
  manufacturingSuppliers: ManufacturingSupplierReducer,
  manufacturingRawMaterials: ManufacturingRawMaterialReducer,
  manufacturingReadyMaterials: ManufacturingReadyMaterialReducer,
  manufacturingAccounts: ManufacturingAccountsReducer,
  fulfillmentOrders: FulfillmentOrderReducer
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'product', 'company'] // sirf yeh reducers persist honge
};

export default persistReducer(persistConfig, rootReducer);
